import React, { useState } from 'react';
import './Header.css'
import { Link } from 'react-router-dom';
import {
    Navbar,
    NavbarBrand,
    Nav,
    NavItem,
    NavbarToggler,
    Collapse,
} from 'reactstrap'
import Logo from '../../assets/logo.png'

import { connect } from 'react-redux';

const mapStateToProps = state => {
    return {
        token: state.token,
    }
}

const Header = props => {
    const [isOpen, setIsOpen] = useState(false);
    let toggle = () => setIsOpen(!isOpen)

    let links = null;

    if (props.token === null) {
        links = <Collapse navbar isOpen={isOpen}><Nav className='mr-md-4' navbar style={{ marginLeft: 'auto' }}>
            <NavItem>
                <Link to='/login' className="Link" onClick={toggle}>Login</Link>
            </NavItem>
        </Nav></Collapse>
    } else {
        links = <Collapse navbar isOpen={isOpen}> <Nav className='mr-md-5' navbar style={{ marginLeft: 'auto' }}>
            <NavItem>
                <Link to='/home' className="Link" onClick={toggle}>BurgerBuilder</Link>
            </NavItem>
            <NavItem>
                <Link to='/orders' className="Link" onClick={toggle}>Orders</Link>
            </NavItem>
            <NavItem>
                <Link to='/logout' className="Link" onClick={toggle}>Logout</Link>
            </NavItem>
        </Nav></Collapse>
    }
    return (
        <div className='Navigation'>
            <Navbar style={{
                backgroundColor: '#d70f64',
                height: '72px',
            }} expand='sm' light
            >   <NavbarToggler onClick={toggle} style={{ boxShadow: '0.5px 0.5px #888888' }} />
                <NavbarBrand href='/' className='mr-auto ml-md-5 Brand' style={{ marginLeft: '10px' }}>
                    <img src={Logo} alt='Logo' width='80px' />
                </NavbarBrand>
                <div className='container' style={{ backgroundColor: '#D70F64', marginTop: '-10px', }}>
                    {links}
                </div>

            </Navbar>
        </div >
    )
}

export default connect(mapStateToProps)(Header);